import { render, staticRenderFns } from "./learnerindex.vue?vue&type=template&id=2f30df28&"
import script from "./learnerindex.vue?vue&type=script&lang=ts&"
export * from "./learnerindex.vue?vue&type=script&lang=ts&"
import style0 from "./learnerindex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports